import itly from 'itly';
import React, { useMemo, useCallback } from 'react';
import { Message } from '../types';
import ReactMarkdown from 'react-markdown';
import { Bubble, MessageBubbleWrapper } from './styles';
import { getContentWithoutHalfLinks } from './helpers';

export const MessageBubble = React.forwardRef<HTMLDivElement, { message: Message }>(({ message }, ref) => {
  const isMarkdown = message.role === 'assistant';

  const contentWithoutHalfLinks = useMemo(() => getContentWithoutHalfLinks(message.content), [message.content]);

  const handleLinkClick = useCallback((event: any) => {
    const link = event.currentTarget;
    const url = link.href;
    itly.productAssistantLinkClicked({ link: url, current_url: window.location.href });
  }, []);

  return (
    <MessageBubbleWrapper ref={ref} isUser={message.role === 'user'} className={`bubble-${message.role}`}>
      <Bubble isUser={message.role === 'user'}>
        {isMarkdown && (
          <div className="markdown">
            <ReactMarkdown
              components={{
                a: ({ node, href, children, ...props }) => {
                  // We're not using Gatsby links because sometimes it causes a full refresh
                  // If we figure out why the refresh is happening, we may add this back.
                  //
                  // href = href.replace('https://www.artifactuprising.com/', '/');
                  // if (href && href.startsWith('/')) {
                  //   return (
                  //     <AULink path={href} id={`link-${href}`} linkToGatsby={true} onClick={handleLinkClick}>
                  //       {children}
                  //     </AULink>
                  //   );
                  // } else {
                  return (
                    <a onClick={handleLinkClick} href={href} target="_blank" rel="noopener noreferrer" {...props}>
                      {children}
                    </a>
                  );
                  // }
                }
              }}
            >
              {contentWithoutHalfLinks}
            </ReactMarkdown>
          </div>
        )}
        {!isMarkdown && <p>{contentWithoutHalfLinks}</p>}
      </Bubble>
    </MessageBubbleWrapper>
  );
});
